// extracted by mini-css-extract-plugin
module.exports = {"customRadio":"Switch_customRadio__1Sxc9"};